import React, { useContext } from 'react';
import FinancialImpactBar from '../FinancialImpactBar/FinancialImpactBar';
import GetImpactAcrossTimeText from '../../../services/Content/GetImpactAcrossTimeText';
import { WindowSizeContext } from '/src/App';

import './style.css';

const FinancialImpactBars = ({ impactValues }) => {
    const { deviceType } = useContext(WindowSizeContext);
    const impactData = GetImpactAcrossTimeText();
    
    return (
        <div className={`financial-impact-bars-container ${deviceType}`}>
            {impactData.map((impact, index) => (
                <FinancialImpactBar
                    key={impact.id}
                    impactData={impact}
                    barValue={impactValues[index]}
                    index={index}
                />
            ))}
        </div>
    );
};

export default FinancialImpactBars;
